module.exports = __webpack_public_path__ + "img/protection.23866994.jpg";